import { Typography, styled } from '@mui/material';
import { withDefaults } from '../../utils/withDefaults';
const RootRoot = styled(Typography)(({
  theme
}) => ({
  margin: theme.spacing(1, 'auto', 1.5),
  color: theme.palette.grey[900],
  maxWidth: 650
}));
export const Root = withDefaults(RootRoot, {
  variant: 'Lato Body 1',
  textAlign: 'center'
});